import { useAuthContext } from '../../hooks';
import React, { createContext, useEffect, useState } from 'react';
import { getAdminNewNotificationsApi } from '../../services/notification/notification.api';

const AdminNotificationContext = createContext<IAdminNotificationContext>({
  loading: true,
});

export interface IAdminNotificationContext {
  notificationsCount?: number;
  getNotificationsCount?: () => void;
  loading: boolean;
}

interface AdminNotificationProviderProps {
  children: React.ReactNode;
}

function AdminNotificationProvider({
  children,
}: AdminNotificationProviderProps) {
  const [notificationsCountLoading, setNotificationsCountLoading] =
    useState(true);
  const [notificationsCount, setNotificationsCount] = useState<number>();
  const { isAuthenticated, user } = useAuthContext();

  async function getNotificationsCount() {
    setNotificationsCountLoading(true);
    try {
      const res = await getAdminNewNotificationsApi({
        page: 1,
        pageSize: 0,
      });
      setNotificationsCount(res?.data.newNotificationsCount);
    } catch (error) {
      console.error(error);
    } finally {
      setNotificationsCountLoading(false);
    }
  }

  useEffect(() => {
    if (
      !isAuthenticated() ||
      (user?.role !== 'TEACHER' && user?.role !== 'SCHOOL')
    ) {
      return;
    }
    const TIME_MINUTES = 1;
    const timer = setInterval(() => {
      getNotificationsCount();
    }, TIME_MINUTES * 1000 * 60);

    return () => clearInterval(timer);

    //eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    if (
      (isAuthenticated() && user?.role === 'TEACHER') ||
      user?.role === 'SCHOOL'
    ) {
      getNotificationsCount();
    }
  }, [isAuthenticated, user?.role]);

  return (
    <AdminNotificationContext.Provider
      value={{
        notificationsCount,
        getNotificationsCount,
        loading: notificationsCountLoading,
      }}
    >
      {children}
    </AdminNotificationContext.Provider>
  );
}

export { AdminNotificationContext, AdminNotificationProvider };
